<template>
  <div class="bottom-div" style="">
    <div
        class="main-chart"
        style="display: flex; flex-direction: row-reverse; float: right; max-width: 600px;"
    >
      <div class="menu-wrapper">
        <ul class="sub-menu-dropup">
          <li
              v-for="tab in tabs"
              :key="tab.id"
              :class="{
              active: selectedTab === tab.alias
            }"
              class="dropdown-item btn btn-block btn-light-gray"
              style="padding: 0; font-size: 11px; font-weight: 500;"
              @click="setClickFromMenu(tab.alias)"
          >
            <span>
              <i class="fas fa-caret-left"></i>
            </span>
            <span class="tabName"> {{ tab.name }}</span>
          </li>
        </ul>
      </div>
      <canvas id="users-stats-main-chart"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import apiClientCreator from "../../../../helpers/api/request";
import ChartDataLabels from "chartjs-plugin-datalabels";

const retChartData = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          // return value === 0 ? value : value;
          return value;
        }
      }
    },
    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          stacked: true,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          stacked: true,
          id: "bar-x-axis1",
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      mode: "index",
      intersect: false
    }
  }
};

export default {
  name: "UsersTopRightChartsContainer",
  props: {
    queryObject: {
      type: Object
    },
  },
  data() {
    return {
      retChartData: retChartData,
      selectedTab: "how_many_filled",
      loading: false,
      filledShiftsStats: [],
      tabs: [
        { id: 1, alias: 'how_many_filled', name: 'HMF' },
        // { id: 2, alias: 'next_week', name: 'WNW' },
        // { id: 3, alias: 'came_early', name: 'CE' },
        // { id: 4, alias: 'came_late', name: 'CL' },
        // { id: 5, alias: 'came_on_time', name: 'COT' },
      ]
    };
  },
  mounted() {
    this.fetchStats();
  },

  watch: {
    queryObject: function() {
      this.fetchStats();
    },
    rangePaymentMethodData: function() {
      this.createChart();
    },
    selectedTab: function() {
      this.fetchStats(this.selectedTab);
    }
  },
  methods: {
    setClickFromMenu(tab) {
      this.selectedTab = tab;
    },

    fetchStats() {
      apiClientCreator(`users/graphs/how_many_filled_shifts`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.filledShiftsStats = res.data;
            this.createChart(this.filledShiftsStats)
          });
    },
    async createChart(filledShiftsStats) {
      let labels = ['Users'];
      let CountAll = [];
      let CountFilled= [];
      let chartData = this.retChartData;
      let opt = chartData.options;
      let chartId = "users-stats-main-chart";

      if(filledShiftsStats.length > 0){
        filledShiftsStats.forEach(r => {
          r.name === 'all' ? CountAll.push(r.count):CountFilled.push(r.count);
        });
      }

      if (this.retChartBar) {
        this.retChartBar.destroy();
      }

      const data = {
        labels: labels,

        datasets: [
          {
            type: "bar",
            label: 'How many filled shifts for next week',
            data: CountFilled,
            fill: true,
            borderColor: "black",
            backgroundColor: "rgb(68,255,0)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            hidden: false
          },
          {
            type: "bar",
            label: 'Total users',
            data: CountAll,
            fill: true,
            borderColor: "black",
            backgroundColor: "rgba(255,0,0,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            hidden: false
          }
        ]
      };

      const ctx = document.getElementById(chartId);

      this.retChartBar = new Chart(ctx, {
        type: chartData.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    }
  }
};
</script>

<style scoped>
.bottom-div {
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
  width: calc(44%);
}

.main-chart {
  width: 100%;
  height: 200px;
  margin: 5px;
}

.menu-wrapper {
  float: right;
  position: relative;
  top: 5px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

li.active {
  background-color: #c12fff;
  color: #fff;
}

span.tabName {
  padding-left: 10px;
}
</style>
